/**
 * WorkspacePresentationRenderer
 * Correção 3 Camada 3 + Camada 4 (tipografia e hierarquia)
 *
 * Dispatcher principal do sistema de apresentação do Workspace.
 * Não altera Home, voz, memória, Cognitive Space.
 * Camadas 1 e 2 (backend) permanecem inalteradas.
 */

import React from 'react';
import './presentation.css';      // Camada 4: CSS vars tipográficas

import {
  RecipePresentation,
  BibleStudyPresentation,
  StudyNotePresentation,
  StepByStepPresentation,
  ComparisonPresentation,
  GenericPresentation,
} from './layouts.jsx';

// layout_type → renderer
const LAYOUT_RENDERERS = {
  recipe:         RecipePresentation,
  study:          StudyNotePresentation,
  bible_study:    BibleStudyPresentation,
  comparison:     ComparisonPresentation,
  tutorial:       StepByStepPresentation,
  // All other layouts fall back to generic presentation
  // (no specific legacy components exist for these layouts)
  plan:           GenericPresentation,
  checklist:      GenericPresentation,
  schedule:       GenericPresentation,
  finance:        GenericPresentation,
  travel:         GenericPresentation,
  timeline:       GenericPresentation,
  research_brief: GenericPresentation,
  summary:        GenericPresentation,
  document:       GenericPresentation,
  table:          GenericPresentation,
  code_explanation: GenericPresentation,
  analysis:       GenericPresentation,
  report:         GenericPresentation,
  book_summary:   GenericPresentation,
};

export default function WorkspacePresentationRenderer({
  layoutType,
  presentationType,
  presentationMeta,
  content,
  AthenaPresentationEngine,
  cognitiveProfile,
  workspacePresentation,
}) {
  // Guarda secundária (Blocker 4): se a mensagem tem workspace_presentation
  // layout 'recipe', o RecipeShowcaseRenderer é o único dono — nunca renderizar
  // o RecipePresentation legado por cima.
  const effectiveLayoutType =
    workspacePresentation?.layout === 'recipe' && layoutType === 'recipe'
      ? 'simple_conversation'
      : layoutType;
  // simple_conversation e indefinidos: delegar ao renderer de texto existente,
  // mas dentro da classe ws-presentation para herdar a tipografia da Camada 4.
  if (!effectiveLayoutType || effectiveLayoutType === 'simple_conversation') {
    return (
      <div className="ws-presentation">
        {AthenaPresentationEngine
          ? <AthenaPresentationEngine content={content} cognitiveProfile={cognitiveProfile} />
          : <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>
        }
      </div>
    );
  }

  const Renderer = LAYOUT_RENDERERS[effectiveLayoutType];

  if (!Renderer) {
    // Layout desconhecido: fallback gracioso para texto
    return (
      <div className="ws-presentation">
        {AthenaPresentationEngine
          ? <AthenaPresentationEngine content={content} cognitiveProfile={cognitiveProfile} />
          : null
        }
      </div>
    );
  }

  return (
    // ws-presentation aplica a tipografia base da Camada 4
    <div className="ws-presentation" style={{ width: '100%', marginTop: 4 }}>
      <Renderer
        content={content}
        title={presentationMeta?.title || null}
        meta={presentationMeta}
        AthenaPresentationEngine={AthenaPresentationEngine}
        cognitiveProfile={cognitiveProfile}
      />
    </div>
  );
}
